import api from "apis/inspectorCases";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getAssignedCases = (inspectorId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getAssignedCases(inspectorId),
  successCallback,
  mountedRef,
});

export const getAssignedCasesByEmployeeId = (employeeId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getAssignedCasesByEmployeeId(employeeId),
  successCallback,
  mountedRef,
});

export const getCaseAppointments = (inspectorId, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: api.getCaseAppointments(inspectorId),
  successCallback,
  mountedRef,
});

export const postExtensionRequest = (controlIdNumber, dueDate, details, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.postExtensionRequest(controlIdNumber),
  payload: {
    dueDate,
    details
  },
  successCallback,
  mountedRef,
});
